// extracted by mini-css-extract-plugin
export default {"detail-section":"DetailDescriptionSection_detail-section__nyCdx","title":"DetailDescriptionSection_title__Xfcst","title-select":"DetailDescriptionSection_title-select__eWSE8"};